import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';

import STYLES from './PlaceholderFlightEntry.module.scss';

const PlaceholderFlightEntry = () => {
  const airlineIconEl = (
    <div className={STYLES.PlaceholderFlightEntry__airlineIcon} />
  );
  const airlineEl = <div className={STYLES.PlaceholderFlightEntry__airline} />;
  const flightCodeEl = (
    <div className={STYLES.PlaceholderFlightEntry__flightCode}>
      <div className={STYLES.PlaceholderFlightEntry__flightCodeShimmer} />
    </div>
  );
  const locationEl = (
    <div className={STYLES.PlaceholderFlightEntry__location}>
      <div className={STYLES.PlaceholderFlightEntry__locationShimmer} />
    </div>
  );
  const timeEl = (
    <div className={STYLES.PlaceholderFlightEntry__scheduledTime} />
  );
  const terminalEl = (
    <div className={STYLES.PlaceholderFlightEntry__terminal} />
  );
  const gateEl = <div className={STYLES.PlaceholderFlightEntry__gate} />;
  const statusEl = <div className={STYLES.PlaceholderFlightEntry__status} />;

  return (
    <BpkPanel className={STYLES.PlaceholderFlightEntry}>
      <div className={STYLES.PlaceholderFlightEntry__wrapperMobile}>
        <div className={STYLES.PlaceholderFlightEntry__topContainer}>
          {airlineIconEl}
          {airlineEl}
          {flightCodeEl}
          <div className={STYLES.PlaceholderFlightEntry__topContainerLeft}>
            {terminalEl}
            {gateEl}
          </div>
        </div>
        <div className={STYLES.PlaceholderFlightEntry__middleContainer}>
          {timeEl}
          <div className={STYLES.PlaceholderFlightEntry__middleContainerBottom}>
            {locationEl}
            {statusEl}
          </div>
        </div>
      </div>

      <div className={STYLES.PlaceholderFlightEntry__wrapper}>
        <div className={STYLES.PlaceholderFlightEntry__wrapperInner}>
          <div className={STYLES.PlaceholderFlightEntry__iconAirline}>
            {airlineIconEl}
            {airlineEl}
          </div>
          {flightCodeEl}
          <div className={STYLES.PlaceholderFlightEntry__timeAndTimeDelayed}>
            {timeEl}
          </div>
          {locationEl}
          {statusEl}
          <div className={STYLES.PlaceholderFlightEntry__terminalGate}>
            {terminalEl}
            {gateEl}
          </div>
        </div>
      </div>
    </BpkPanel>
  );
};

export default PlaceholderFlightEntry;
